<!--begin::Logo image-->
<a routerLink="/">
  <ng-container *ngIf="currentLayoutType === 'dark-sidebar'">
    <img alt="Logo" src="./assets/media/logos/default-invert.svg" class="h-25px app-sidebar-logo-default" />
  </ng-container>
  <ng-container *ngIf="currentLayoutType !== 'dark-sidebar'">
    <img alt="Logo" src="./assets/media/logos/default.svg" class="h-25px app-sidebar-logo-default theme-light-show" />
    <img alt="Logo" src="./assets/media/logos/default_icon.svg"
      class="h-25px app-sidebar-logo-default theme-dark-show" />
  </ng-container>

  <img alt="Logo" src="./assets/media/logos/default_icon.svg" class="h-20px app-sidebar-logo-minimize" />
</a>
<!--end::Logo image-->


<ng-container *ngIf="toggleEnabled">
  <!--begin::Sidebar toggle-->
  <div id="kt_app_sidebar_toggle"
    class="
      app-sidebar-toggle btn btn-icon
      btn-shadow btn-sm btn-color-muted
      btn-active-color-primary body-bg h-30px w-30px
      position-absolute top-50 translate-middle rotate
    "
    [ngClass]="toggleButtonClass"
    [attr.data-kt-toggle-state]="toggleState"
    [attr.data-kt-toggle-name]="toggleAttr"
    data-kt-toggle="true"
    data-kt-toggle-target="body"
  >
    <span [inlineSVG]="'./assets/media/icons/ic_mini_arrow_left.svg'" class="svg-icon svg-icon-2 rotate-180"></span>
  </div>
  <!--end::Sidebar toggle-->
</ng-container>
